import React from 'react';
import { ChevronRightIcon, LockIcon } from 'lucide-react';
import { useLocale } from '../contexts/LocaleContext';
import { useMetrics } from '../contexts/MetricsContext';
import type { MetricKind } from '../types';
import { formatMetric } from '../utils/units';
interface MetricRowProps {
  label: string;
  kind: MetricKind;
  value: number;
  /** Calculated metrics are read-only, like BMI. */
  derived?: boolean;
  hint?: string;
  onOpen?: () => void;
  action?: React.ReactNode;
}
export function MetricRow({
  label,
  kind,
  value,
  derived = false,
  hint,
  onOpen,
  action
}: MetricRowProps) {
  const {
    t
  } = useLocale();
  const {
    unitSystem
  } = useMetrics();
  // Missing values never carry a unit. BMI without weight/height reads "—".
  const display = value > 0 ? formatMetric(kind, value, unitSystem) : kind === 'bmi' ? '—' : t('metrics.notSet');
  const body = <>
      <span className="min-w-0 flex-1" data-id="element-1050" data-mp="tggaumqbsqv2">
        <span className="flex items-center gap-1 text-[13.5px] font-medium text-deep" data-id="element-1051" data-mp="tfeovn7rujyk">
          {label}
          {derived && <LockIcon size={11} className="text-muted" aria-hidden="true" data-id="element-1052" data-mp="am73k75vht9r" />}
        </span>
        {hint && <span className="mt-[2px] block text-[11px] leading-snug text-muted" data-id="element-1053" data-mp="3s1x60fv7lpi6">
            {hint}
          </span>}
      </span>
      <span className="bee-num shrink-0 text-[14px] font-bold text-deep" data-id="element-1054" data-mp="ukmhu6uszz3">
        {display}
      </span>
    </>;
  return <li className="flex items-center gap-2 border-b border-sand-line last:border-b-0" data-id="element-1055" data-mp="3o1d5r3fca5rt">
      {onOpen ? <button type="button" onClick={onOpen} aria-label={`${label} — ${t('metrics.openChart')}`} className="flex min-h-[56px] flex-1 items-center gap-2 py-2 text-left" data-id="element-1056" data-mp="394cfl4csqivg">
          {body}
          <ChevronRightIcon size={16} className="shrink-0 text-muted" aria-hidden="true" data-id="element-1057" data-mp="17e0zdmkrovzl" />
        </button> : <div className="flex min-h-[56px] flex-1 items-center gap-2 py-2" data-id="element-1058" data-mp="1av6ktrpf3xmh">
          {body}
        </div>}
      {action}
    </li>;
}